import * as actions_invoices from 'actions/invoices-actions';
import * as actions_profiles from 'actions/profiles-actions';
import * as actions_service_requests from 'actions/service-requests-actions';
import * as actions_users from 'actions/users-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect, useState } from 'react';
import ResultsActionIcons from './results-actions/results-action-icons';
import _ from 'lodash';
import { APPS, INVOICES, SERVICE_REQUEST_TERMS } from 'components/constants';
import { Avatar, DashboardDetail, Spinner } from 'enspire-manager-framework';
import { Table } from 'em-table';
import { imageSize } from 'components/common/toolbox';
import { navMultipleUrls, numPanels } from 'components/common/toolbox';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

var moment = require('moment');

const ResultsInvoices = (props) => {
    
    /* Hooks -----------------------------*/
    
    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
	const routeLocation = useLocation();

    const employees = useSelector((store) => store.employees.employees);
    const profiles = useSelector((store) => store.profiles);
    const invoices = useSelector((store) => store.invoices);;
    const user = useSelector((store) => store.users.user);

    const [data, setData] = useState([]);

    const type = (params.appId == APPS.DISPATCH.id) ? 'service_request' : 'asset_request';
    const typeInvoices = _.filter(invoices.invoices_dashboard, (inv) => inv['type'] == type);
    const orderedInvoices = _.orderBy(typeInvoices, ['_displayName'], ['asc']);
	const segments = routeLocation.pathname.split('/').length;
    
    /* UseEffect --------------------------*/

    useEffect(() => {
        if (params.widget_id == 'dashboard') {
            dispatch(actions_invoices.clearDashboardInvoices());
        } else {
            dispatch(actions_invoices.subDashboardInvoices(params.handle, params.appId, params.widget_id));
        }
        
        return () => {
			const unsubscribe = invoices.invoices_dashboard_unsubscribe;
			if (typeof unsubscribe == 'function') unsubscribe();
		};
    }, [params.handle, params.appId, params.widget_id]);

    useEffect(() => {
		if (parseInt(params.customer_id)) dispatch(actions_profiles.subProfile(params.handle, params.appId, params.customer_id, 'PROFILE'));
		return () => {
			let unsubscribe = profiles.profile_unsubscribe;
			if (typeof unsubscribe === "function") unsubscribe();
			dispatch(actions_profiles.clearProfile());
		};
	}, [params.customer_id]);

    useEffect(() => {    
        var invoices_array = [];
        var currentEntityId = null;
        orderedInvoices?.forEach((invoice) => {
            
            const customerId = invoice.customerId;
            const status = _.find(Object.values(INVOICES), { id: invoice.statusId });
            const owner = _.find(employees, (o) => o.contact?.email == invoice?.ownerId);

            // Add group heading for customer or asset
            if (customerId != currentEntityId) {
                currentEntityId = customerId;
                invoices_array.push({ ...invoice,
                    status: status?.name,
                    _jsx:
                    <div className="d-flex p-2" style={{ backgroundColor: '#dddddd' }}>
                        <div role="button" onClick={() => openEntity(invoice)}>
                            <Avatar className=""
                                color="white"
                                bgColor="saddleBrown"
                                size={45}
                                fontSize={'20px'}
                                name={ (invoice._displayName) ? invoice._displayName : 'Internal' }
                                image={imageSize(invoice._imageUrl, 'sm')}
                                imageWidth={60}
                                border="4px solid white"
                                role={ (invoice._imageUrl) ? "button" : null }
                                style={{ flexShrink: 0 }}
                            />
                        </div>
                        <div className="align-self-center">
                            <h2 className="ml-3 m-0 text-black font-weight-normal">{ (invoice._displayName) ? invoice._displayName : 'Internal' }</h2>
                            { invoice._address &&
                                <p className="ml-3 m-0">{ invoice._address }</p>
                            }
                        </div>
                    </div> 
                });
            }
            
            invoices_array.push({ ...invoice,
                status: status?.name,
                _stripe_color: status?.color,
                details: <>
                    <div className="d-flex justify-content-between">
                        <h1 className="main-heading heading-invoice align-self-start mx-2">
                            Invoice #{invoice.id}
                        </h1>
                        <p className="mb-2 mr-auto">{ moment(invoice.invoiceDate?.toDate()).format('MMM Do, YYYY') }</p>
                    </div>
                    <div id="quote-details" className="mt-2 mb-2">
                        <DashboardDetail field={ 'Technician Id' } value={ (invoice.technicianId != "unassigned") ? invoice.technicianId : "UNASSIGNED" } />
                        <DashboardDetail field={ 'Invoice Date' } value={ moment(invoice.invoiceDate?.toDate()) } format='MMM DD, YYYY' type="moment" />
                        <DashboardDetail field={ 'Summary' } value={ invoice._description } type="text" />
                        <DashboardDetail field={ 'Created By' } value={ `${owner?.contact.firstName} ${owner?.contact.lastName}` } type="text" />
                        <div className="clearfix"></div>
                    </div>
                    <div className="d-flex align-items-end justify-content-between">
                        <ResultsActionIcons entity={ 'invoice' } invoice={ invoice } entityId={ invoice.id } sms={ false } />
                        <button className="btn btn-default btn-lg btn-circle ml-3" onClick={ () => openInvoice(invoice) }>
                            <i className="fa-duotone fa-solid fa-chevrons-right"></i>
                        </button>
                    </div>

                </>
            });
        });
        setData(invoices_array);
    }, [invoices.invoices_dashboard, routeLocation.pathname]);

    /* Actions ----------------------------*/

    const openInvoice = async (invoice) => {
        let num = (segments >= 11) ? -2 : (segments >= 10) ? -1 : 0;
        if (num) history.go(num);

        const entityId = (params.appId == APPS.DISPATCH.id) ? invoice.customerId : invoice.assetId;
        const serviceRequest = await actions_service_requests.getServiceRequestById(params.handle, invoice.requestId);
        const workOrderIds = await actions_service_requests.getWorkOrderIdsByServiceRequestId(params.handle, invoice.requestId);

        if (serviceRequest.serviceRequestTermsId == SERVICE_REQUEST_TERMS.SERVICE_CALL.id) {
            navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests`, 7),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${invoice.requestId}/work_orders/${workOrderIds[0]}/invoices`, 11),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${invoice.requestId}/work_orders/${workOrderIds[0]}/invoices/preview/${invoice.id}`, 13),
            ]});
        } else {
            navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests`, 7),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${invoice.requestId}/invoices`, 9),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${invoice.requestId}/invoices/preview/${invoice.id}`, 11),
            ]});
        }
    }
    const openEntity = (invoice) => {
        const entityId = (params.appId == APPS.DISPATCH.id) ? invoice.customerId : invoice.assetId;
        const tab = (params.appId == APPS.DISPATCH.id) ? 'tab' : 'service_requests';

        navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
            toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/${tab}`, 7),
        ]});    
    }

    /* Constants --------------------------*/

    const columns = [
        { name: 'Details', field: 'details', type: 'jsx', width: 100 },
    ];

    return (

        <Table
            data={data}
            columns={columns}
            active_field={'id'}
            active_id={params.tab3_id}
            group_by={{ fields: ['statusId'], direction: ['desc'], display: ['status'] }}
            hide_header={true}
        >
        </Table>
    );
};

export default ResultsInvoices;